<template>
  <b-form
    inline
    class="align-items-start"
  >
    <b-form-group class="flex-grow-1 mr-3">
      <b-form-textarea
        v-model="msg"
        :placeholder="$t('forms.chat_message.placeholder')"
        rows="3"
        max-rows="6"
        class="textarea"
        :disabled="disabled"
        @keyup.enter.ctrl="send()"
        ref="textarea"
      />
      <b-alert
        variant="secondary"
        class="mt-2 p-1"
        :show="invalid"
      >
        {{ $t('forms.chat_message.limit_exceed') }} {{ msg.length }}/{{ limit }}
      </b-alert>
    </b-form-group>
    <b-form-group style="position: relative;">
      <b-button
        variant="secondary"
        @click.prevent="send()"
        :disabled="disabled || !msg || invalid"
      >
        Отправить
      </b-button><br>
      <b-button
        variant="secondary"
        size="sm"
        class="mt-2"
        @click.prevent="toggleEmoji()"
      >
        😃
      </b-button>

      <picker v-show="showEmoji" set="apple" :data="emojiData" :i18n="emojiI18n" title="Смайлики" @select="selectEmoji" :style="{ position: 'absolute', bottom: '0', right: '115%' }" />
    </b-form-group>
  </b-form>
</template>

<script>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import dataEmoji from 'emoji-mart-vue-fast/data/apple'
// import emojiRegex from 'emoji-regex'

import 'emoji-mart-vue-fast/css/emoji-mart.css'

let exclude = ['flags']

let emojiIndex = new EmojiIndex(dataEmoji, {
  exclude
})

export default {
  components: {
    Picker
  },
  model: {
    prop: 'message',
    event: 'send'
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 2000
    }
  },
  data: () => ({
    msg: '',
    // _msg: '',
    invalid: false,

    pack: {},
    showEmoji: false,
    emojiData: emojiIndex
  }),
  computed: {
    emojiI18n () {
      return {
        search: this.$t('chat.emoji.search'),
        notfound: this.$t('chat.emoji.notfound'),
        categories: {
          search: this.$t('chat.emoji.categories.search'),
          recent: this.$t('chat.emoji.categories.recent'),
          people: this.$t('chat.emoji.categories.people'),
          nature: this.$t('chat.emoji.categories.nature'),
          foods: this.$t('chat.emoji.categories.foods'),
          activity: this.$t('chat.emoji.categories.activity'),
          places: this.$t('chat.emoji.categories.places'),
          objects: this.$t('chat.emoji.categories.objects'),
          symbols: this.$t('chat.emoji.categories.symbols'),
          flags: this.$t('chat.emoji.categories.flags'),
          custom: this.$t('chat.emoji.categories.custom')
        }
      }
    }
  },
  watch: {
    message (message) {
      this.msg = message
    },
    msg (message) {
      this.invalid = message.length > this.limit
    }
  },
  created () {
    this.msg = this.message
  },
  methods: {
    updateMessage (e) {
      console.log(e)
    },
    toggleEmoji () {
      this.showEmoji = !this.showEmoji
    },
    selectEmoji (emoji) {
      // this.msg = this.msg + emoji.colons
      this.msg += emoji.native
      // this.msg = wrapEmoji(this.msg)
      // this._msg += emoji.native
    },
    send () {
      if (!this.msg) {
        return
      }
      this.showEmoji = false
      this.$emit('send', this.msg)
      this.$refs.textarea.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  .textarea {
    width: 100%;
    border-width: 3px;
    border-color: rgb(165, 144, 162);
    &::placeholder {
      color: rgb(165, 144, 162);
    }
  }
  .message {
    width: 100%;
    height: 8rem;
    border-width: 3px;
    border-color: #a590a2;

    &[placeholder]:empty:before {
      content: attr(placeholder);
      color: rgb(165, 144, 162);
    }
  }
</style>
